// POSTHOG TRACKING - START
// Shared Product Pages tracking (see POSTHOG_TRACKING.md's "Product Pages" section for the full
// event/trigger/properties reference). Loaded as a plain static asset on every product page
// directly from layout/theme.liquid ({% if template.name == 'product' %}...{% endif %}) - not
// included in any product template, and not a .liquid-processed file, so there's no Liquid
// available here (product_handle is derived client-side from the URL instead, below). This file
// replaces the per-product block_html_section_posthogTracking blocks that used to be
// copy-pasted into each product.v3.<handle>.schema.json - every handler below is either already
// generic (a shared component's class, identical everywhere it's used) or made generic by
// detecting a component structurally instead of relying on a per-product wrapper class or
// Shopify section id. Nothing here needs editing when a new product template is created - it
// either fires (the component exists) or sits inert (it doesn't), same "harmless if absent"
// convention used throughout this file.
// product_handle: derived from the URL rather than {{ product.handle | json }} since this file
// is never Liquid-processed. PDP URLs always contain /products/<handle> regardless of market
// subfolder, so this is reliable without any Liquid. Computed once, globally, in layout/theme.liquid
// (window.pdpProductHandle) rather than here, so every PDP slider's own inline script can read the
// same value instead of each one re-running this regex separately.
var pdpProductHandle = window.pdpProductHandle;

// Accordion "kind" classifier, shared by every accordion-related handler below. All of the
// generic "details" accordion (Ingredients & nutritional info / Comparison table / Benefits /
// Product info video / one-off accordions like "Myth or truth?" / etc.), References, How Feel
// Works, Health Journey and FAQ render through the same generic accordion markup
// (.accordion__item > .accordion__item__header), so distinguishing them by a per-product
// wrapper class or section id doesn't scale to a shared file. Instead:
// - How Feel Works / Health Journey / FAQ each render through their own dedicated snippet,
//   which always wraps its output in a fixed, snippet-owned class regardless of product
//   (.how-feel-works__accordion-styles / .accordion__health-timeline / .product-faq-default).
// - The details accordion and References are both rendered by the same generic
//   block-accordion snippet (snippets/accordions-v3.liquid) with only merchant-configured
//   content differing per product, so there's no positive class to key off. References is
//   instead detected by content: every References-type item's content contains a citation
//   link wrapped in .accordion__references-list-item (already relied on elsewhere as a
//   universal selector - see pdp_reference_link_clicked below) - verified against all 27
//   products' actual accordion content when this file was introduced, zero false
//   positives/negatives.
// - Anything else defaults to "details" - deliberately not named "ingredients" since this
//   accordion also carries Comparison table/Benefits/Product info video content and
//   genuinely one-off accordions (e.g. feel-pro-creatine-lemon-lime's "Myth or truth?"/"Myths
//   about Creatine"), all folded into pdp_details_accordion_toggled rather than inventing new
//   events per content type.
function pdpAccordionKind($header) {
	if ($header.closest('.how-feel-works__accordion-styles').length) return 'how_it_works';
	if ($header.closest('.accordion__health-timeline').length) return 'health_journey';
	if ($header.closest('.product-faq-default').length) return 'faq';
	if ($header.closest('.accordion__item').find('.accordion__references-list-item').length) return 'references';
	return 'details';
}

// Hero card - quantity stepper
$('body').on('click', '.product-hero__quantity__add, .product-hero__quantity__remove', function () {
	posthogCapture('pdp_quantity_changed', {
			direction: $(this).hasClass('product-hero__quantity__add') ? 'increase' : 'decrease',
			product_handle: pdpProductHandle
		});
});

// Hero card - "See full ingredients list" (opens the nutritional-ingredients modal,
// not the same modal/event as product_modal_opened)
$('body').on('click', '.product-hero__button-ingredients', function () {
	posthogCapture('pdp_full_ingredients_modal_opened', {
			product_handle: pdpProductHandle
		});
});

// Full-ingredients modal close
$('body').on('click', '#nutritional-ingredients-modal .modal-header .close', function () {
	posthogCapture('pdp_full_ingredients_modal_closed', {
			product_handle: pdpProductHandle
		});
});

// Hero card - "more benefits" (opens a separate modal from product_modal_opened's .button__hero-modal)
$('body').on('click', '.product-hero__modal[data-product-all-benefits]', function () {
	posthogCapture('pdp_more_benefits_modal_opened', {
			product_handle: pdpProductHandle
		});
});

// Hero card - "Free-from" collapse (Bootstrap data-toggle="collapse" - this body-delegated
// handler fires before Bootstrap's own document-level handler flips aria-expanded, so the
// post-click state is the logical inverse of the pre-click attribute)
$('body').on('click', '.product-hero__tabs .custom-collapse-button[data-target=".hero-pdp_free-from"]', function () {
	posthogCapture('pdp_free_from_toggled', {
			expanded: $(this).attr('aria-expanded') !== 'true',
			product_handle: pdpProductHandle
		});
});

// Hero card - boost cross-sell "Learn More" (opens a modal or links to the boost product,
// depending on the boost_product metafield config - not present on every product)
$('body').on('click', '.boost-benefits__product-learn_more', function () {
	posthogCapture('pdp_boost_learn_more_clicked', {
			product_handle: pdpProductHandle
		});
});

// Hero modal (opened by .button__hero-modal, already tracked as product_modal_opened) - close
$('body').on('click', '.product-hero__hero-modal .close-button', function () {
	posthogCapture('pdp_hero_modal_closed', {
			product_handle: pdpProductHandle
		});
});

// Hero modal - health-timeline "Read more/Read less" (only present when health_timeline
// metafield data exists - this file's own body-delegated handler registers first and
// toggles the '__open' class before this one fires, so state below is post-click)
$('body').on('click', '.product-hero__hero-modal .health-improvement__timeline-text_read-more', function () {
	posthogCapture('pdp_hero_modal_timeline_read_more_toggled', {
			expanded: $(this).closest('.health-improvement__timeline-text').hasClass('__open'),
			product_handle: pdpProductHandle
		});
});

// Hero modal - "View timeline"/"View full timeline" toggle
$('body').on('click', '.button__additional-modal', function () {
	posthogCapture('pdp_hero_modal_timeline_view_toggled', {
			view: $('.health-improvement__timeline-full').hasClass('active') ? 'full' : 'small',
			product_handle: pdpProductHandle
		});
});

// Hero modal - extra-benefits Bootstrap collapse (same pre-click/post-click note as Free-from above)
$('body').on('click', '.product-hero__hero-modal .collage-collapse-button[data-toggle="collapse"]', function () {
	posthogCapture('pdp_hero_modal_benefits_collapse_toggled', {
			expanded: $(this).attr('aria-expanded') !== 'true',
			product_handle: pdpProductHandle
		});
});

// Generic "expandable detail" collapse inside a block-image-content block (same
// .collage-collapse-button class as the hero-modal event above, but rendered outside the
// hero modal - e.g. "Why this probiotic matters"/"Clinically supported"/"Key benefits"
// dropdowns). Excludes clicks already handled by the hero-modal event above.
$('body').on('click', '.collage-collapse-button[data-toggle="collapse"]', function () {
	if ($(this).closest('.product-hero__hero-modal').length) return;
	posthogCapture('pdp_image_content_detail_toggled', {
			detail_header: $(this).text().trim(),
			expanded: $(this).attr('aria-expanded') !== 'true',
			product_handle: pdpProductHandle
		});
});

// Hero modal - "Why subscribe" video/benefits tab switch
$('body').on('click', '.product-hero__tab__why-subscribe-tab button', function () {
	posthogCapture('pdp_hero_modal_why_subscribe_tab_clicked', {
			tab: $(this).text().trim(),
			product_handle: pdpProductHandle
		});
});

// Hero modal - "why subscribe" preview video play (poster or center-play button)
$('body').on('click', '.js-preview-play, .js-center-play', function () {
	posthogCapture('pdp_hero_modal_video_played', {
			product_handle: pdpProductHandle
		});
});

// Hero modal - GCC-only "Special Perks"/"Why subscribe" tab switch inside the subscriptions/gifts modal
$('body').on('click', '.subscription-modal-popup-gcc__nav a[data-toggle="tab"]', function () {
	posthogCapture('pdp_hero_modal_gifts_tab_clicked', {
			tab: $(this).text().trim(),
			product_handle: pdpProductHandle
		});
});

// Hero modal - "Next" step button in the subscription/gifts modal
$('body').on('click', '.subscription-modal__button-next', function () {
	posthogCapture('pdp_hero_modal_subscription_next_clicked', {
			product_handle: pdpProductHandle
		});
});

// "How Feel Works" accordion (block-how-feel-works)
$('body').on('click', '.how-feel-works__accordion-styles .accordion__item__header', function () {
	posthogCapture('pdp_how_it_works_toggled', {
			expanded: $(this).closest('.accordion__item').hasClass('accordion__item_active'),
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.how-feel-works__accordion-styles a[href*="/pages/rewards"]', function () {
	posthogCapture('pdp_how_it_works_link_clicked', {
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.how-feel-works__accordion-styles a[href*="/products/"]', function () {
	posthogCapture('pdp_how_it_works_shop_now_clicked', {
			product_handle: pdpProductHandle
		});
});

// "Health improvement timeline" accordion (block-health-journey, only present when
// health-timeline metafield data exists)
$('body').on('click', '.accordion__health-timeline .accordion__item__header', function () {
	posthogCapture('pdp_health_journey_toggled', {
			expanded: $(this).closest('.accordion__item').hasClass('accordion__item_active'),
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.accordion-health-improvement__timeline-content-wrapper-slider-accordion .splide__arrow', function () {
	posthogCapture('pdp_health_journey_slider_arrow_clicked', {
			direction: $(this).hasClass('splide__arrow--prev') ? 'prev' : 'next',
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.accordion-health-improvement__timeline-content-wrapper-slider-accordion .splide__pagination__page', function () {
	posthogCapture('pdp_health_journey_slider_pagination_clicked', {
			slide_index: $(this).closest('li').index(),
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.health-journey__accordion__content .accordion-health-improvement__timeline-text_read-more', function () {
	posthogCapture('pdp_health_journey_read_more_toggled', {
			expanded: $(this).closest('.accordion-health-improvement__timeline-text').hasClass('__open'),
			product_handle: pdpProductHandle
		});
});

// Generic details accordion (block-accordion: Ingredients & nutritional info / Comparison
// table / Benefits / Product info video / one-off accordions / etc.) - see
// pdpAccordionKind() above for how this is told apart from How Feel Works/Health
// Journey/FAQ/References without a per-product wrapper class or section id.
$('body').on('click', '.accordion__item__header', function () {
	if (pdpAccordionKind($(this)) !== 'details') return;
	posthogCapture('pdp_details_accordion_toggled', {
			accordion_header: $(this).find('.accordion__item__header__text').text().trim(),
			expanded: $(this).closest('.accordion__item').hasClass('accordion__item_active'),
			product_handle: pdpProductHandle
		});
});

// Outbound reference link inside the details accordion's own content (distinct from the
// dedicated References accordion's .accordion__references-list-item links, tracked below)
$('body').on('click', '.accordion__content a', function () {
	if ($(this).closest('.accordion__references-list-item').length) return;
	if (pdpAccordionKind($(this)) !== 'details') return;
	posthogCapture('pdp_details_accordion_link_clicked', {
			accordion_header: $(this).closest('.accordion__content').prev('.accordion__item').find('.accordion__item__header__text').text().trim(),
			reference_title: $(this).text().trim(),
			destination_url: $(this).attr('href'),
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.accordion-ingredients__bottom-info .custom-collapse-button[data-toggle="collapse"]', function () {
	posthogCapture('pdp_ingredients_detail_toggled', {
			detail_header: $(this).text().trim(),
			expanded: $(this).attr('aria-expanded') !== 'true',
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.nutritionist-video__video-poster-controls', function () {
	posthogCapture('pdp_ingredients_video_played', {
			product_handle: pdpProductHandle
		});
});

// "Key ingredient highlights" (block-2-columns-cards)
$('body').on('click', '.column-card__read-more__button-toggle', function () {
	posthogCapture('pdp_key_ingredients_read_more_toggled', {
			ingredient: $(this).closest('.column-card__wrapper').find('.column-card__wrapper-top').first().text().trim(),
			expanded: $(this).hasClass('column-card__read-more__button-toggle-active'),
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.column-card__container .splide__arrow', function () {
	posthogCapture('pdp_key_ingredients_slider_arrow_clicked', {
			direction: $(this).hasClass('splide__arrow--prev') ? 'prev' : 'next',
			product_handle: pdpProductHandle
		});
});

// PDP FAQ (pdp-faq-v3 block, only present when the product_faq metafield is populated)
$('body').on('click', '.product-faq-default .accordion__item__header', function () {
	posthogCapture('pdp_faq_toggled', {
			question: $(this).find('.accordion__item__header__text').text().trim(),
			expanded: $(this).closest('.accordion__item').hasClass('accordion__item_active'),
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.product-faq-search .search-bar__icon', function () {
	posthogCapture('pdp_faq_search_icon_clicked', {
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.product-faq-search__clear', function () {
	posthogCapture('pdp_faq_search_cleared', {
			product_handle: pdpProductHandle
		});
});

// Search-result FAQ items are Bootstrap collapses without an aria-expanded attribute -
// use the pre-click 'collapsed' class instead (Bootstrap removes it when opening, so
// reading it before Bootstrap's own handler runs already equals the post-click expanded state)
$('body').on('click', '.product-faq-search-results .faq__black-collapse-button', function () {
	posthogCapture('pdp_faq_search_result_toggled', {
			question: $(this).text().trim(),
			expanded: $(this).hasClass('collapsed'),
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.product-faq-search__show-more', function () {
	posthogCapture('pdp_faq_search_show_more_clicked', {
			product_handle: pdpProductHandle
		});
});

// PDP nutritionists (pdp-nutritionists-v3 block, only present when the nutritionists
// metafield is populated). Guarded against colliding with the page-level nutritionists_*
// events fired by assets/nutritionist-reviews-script-v3.js, which reuses identical class
// names elsewhere on a PDP (the hero-modal's own "Recommended by nutritionists" tab) - see
// POSTHOG_TRACKING.md's "Nutritionists page" section for the full explanation.
function pdpNutritionistName($el) {
	var $card = $el.closest('.nutritionist-card');
	return $card.length ? $card.find('.nutritionist-name').first().text().trim() : $('.nutritionist-about__name').first().text().trim();
}

$('body').on('click', '.pdp-nutritionists__slider .splide__arrow', function () {
	posthogCapture('pdp_nutritionists_slider_arrow_clicked', {
			direction: $(this).hasClass('splide__arrow--prev') ? 'prev' : 'next',
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.nutritionist-about', function () {
	if (!$(this).closest('.pdp-nutritionists__slider').length) return;
	window.pdpNutritionistModalSource = 'pdp';
	posthogCapture('pdp_nutritionist_about_modal_opened', {
			nutritionist_name: pdpNutritionistName($(this)),
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '#nutritionist-about__modal .close', function () {
	if (window.pdpNutritionistModalSource !== 'pdp') return;
	posthogCapture('pdp_nutritionist_about_modal_closed', {
			nutritionist_name: $('.nutritionist-about__name').first().text().trim(),
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.nutritionist-email', function () {
	if (!$(this).closest('.pdp-nutritionists__slider').length && !($(this).closest('#nutritionist-about__modal').length && window.pdpNutritionistModalSource === 'pdp')) return;
	posthogCapture('pdp_nutritionist_email_clicked', {
			nutritionist_name: pdpNutritionistName($(this)),
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.nutritionist-website', function () {
	if (!$(this).closest('.pdp-nutritionists__slider').length && !($(this).closest('#nutritionist-about__modal').length && window.pdpNutritionistModalSource === 'pdp')) return;
	posthogCapture('pdp_nutritionist_website_clicked', {
			nutritionist_name: pdpNutritionistName($(this)),
			destination_url: $(this).attr('href'),
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.nutritionist-read-more', function () {
	posthogCapture('pdp_nutritionist_review_toggled', {
			nutritionist_name: pdpNutritionistName($(this)),
			expanded: $(this).closest('.nutritionist-read-more__wrapper').prev('.nutritionist-content').hasClass('expanded'),
			product_handle: pdpProductHandle
		});
});

// Hardcoded nutritionist-quote carousel (nutritionist-reviews-static-v3 section, distinct
// from the pdp-nutritionists-v3 block above - no filters/modals/email-website icons, just a
// rotating quote slider with pagination dots as the only deliberate nav control)
$('body').on('click', '.pdp-nutritionist-reviews__slider .splide__pagination__page', function () {
	posthogCapture('pdp_nutritionist_reviews_slider_pagination_clicked', {
			slide_index: $(this).closest('li').index(),
			product_handle: pdpProductHandle
		});
});

// Related-products showcase (products-slider-winning-static-v3 - most products have two
// instances sharing the same markup/classes, some have one; one set of listeners covers both)
$('body').on('click', '.product-categories__tab[data-toggle="tab"]', function () {
	posthogCapture('pdp_related_products_tab_clicked', {
			category: $(this).text().trim(),
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.products-slider__item', function () {
	posthogCapture('pdp_related_product_clicked', {
			related_product_handle: ($(this).attr('href') || '').split('/products/').pop(),
			related_product_title: $(this).find('.products-slider__item__header').contents().first().text().trim(),
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.products-slider.black-slider-arrows .splide__arrow', function () {
	posthogCapture('pdp_related_products_slider_arrow_clicked', {
			direction: $(this).hasClass('splide__arrow--prev') ? 'prev' : 'next',
			product_handle: pdpProductHandle
		});
});

// Customer-images (Instagram) slider
$('body').on('click', '.images-slider .splide__arrow', function () {
	posthogCapture('pdp_customer_images_slider_arrow_clicked', {
			direction: $(this).hasClass('splide__arrow--prev') ? 'prev' : 'next',
			product_handle: pdpProductHandle
		});
});

// References accordion (block-accordion) - see pdpAccordionKind() above. accordion_header
// is always included (not just on multi-header products) for schema consistency - it just
// always reads "References" on single-header products.
$('body').on('click', '.accordion__item__header', function () {
	if (pdpAccordionKind($(this)) !== 'references') return;
	posthogCapture('pdp_references_accordion_toggled', {
			accordion_header: $(this).find('.accordion__item__header__text').text().trim(),
			expanded: $(this).closest('.accordion__item').hasClass('accordion__item_active'),
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.accordion__references-list-item a', function () {
	posthogCapture('pdp_reference_link_clicked', {
			accordion_header: $(this).closest('.accordion__content').prev('.accordion__item').find('.accordion__item__header__text').text().trim(),
			reference_title: $(this).text().trim(),
			destination_url: $(this).attr('href'),
			product_handle: pdpProductHandle
		});
});

// Before/after image loop slider (block-image-loop-slider, shared component - present on any
// product using this block, not just the collagen family)
$('body').on('click', '.image-loop-slider .splide__arrow', function () {
	posthogCapture('pdp_before_after_loop_slider_arrow_clicked', {
			direction: $(this).hasClass('splide__arrow--prev') ? 'prev' : 'next',
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.image-loop-slider .splide__pagination__page', function () {
	posthogCapture('pdp_before_after_loop_slider_pagination_clicked', {
			slide_index: $(this).closest('li').index(),
			product_handle: pdpProductHandle
		});
});

// Optional bottom CTA under the loop slider - the block supports either a plain link or
// falls back to .button__get-subscription (already add_to_cart-covered); only the link
// variant is new/untracked
$('body').on('click', '.image-loop-slider-container ~ .row a.button.button-black', function () {
	posthogCapture('pdp_before_after_loop_cta_clicked', {
			destination_url: $(this).attr('href'),
			product_handle: pdpProductHandle
		});
});

// Collagen comparison graph slider (collagen-graph-slider block, shared verbatim with the
// Collagen Science page's own instance - that page's tracking script doesn't cover a PDP's
// instance of the same component, so these are separate pdp_* events)
function pdpCollagenGraphArrowDirection($el) {
	return ($el.hasClass('splide__arrow--prev') || $el.hasClass('splide_prev-custom')) ? 'prev' : 'next';
}

$('body').on('click', '.collagen__graph-slider .splide__arrow, .splide_prev-custom, .splide_next-custom', function () {
	posthogCapture('pdp_collagen_graph_slider_arrow_clicked', {
			direction: pdpCollagenGraphArrowDirection($(this)),
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.collagen__graph-slider-pagination .custom-pagination-btn', function () {
	posthogCapture('pdp_collagen_graph_slider_pagination_clicked', {
			slide_index: $(this).data('slide'),
			label: $(this).text().trim(),
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.collagen__graph-table-button', function () {
	posthogCapture('pdp_collagen_graph_comparison_tab_clicked', {
			tab: $(this).text().trim(),
			product_handle: pdpProductHandle
		});
});

// The functional click handler for this button (snippets/collagen-graph-slider-static-v3.liquid)
// only ever calls addClass('__active') on the button itself - never removes it - so .__active
// stays true forever after the first click and can't distinguish expand from collapse. The real
// toggle state lives in that handler's private showMoreActive closure variable, not exposed on
// the DOM, but it sets the wrapper's max-height to the '30px' collapsed sentinel or the full
// content height before flipping that variable - and since it's a direct binding on the button,
// it runs (and finishes updating that CSS) before this delegated body handler does. Mirror its
// own $(this).parent().find(...) traversal to read the wrapper's post-click state directly.
$('body').on('click', '.collagen__graph-table__show_more_btn', function () {
	var $wrapper = $(this).parent().find('.collagen__graph-table__show_more-wrapper');
	posthogCapture('pdp_collagen_graph_show_more_toggled', {
			expanded: $wrapper.css('max-height') !== '30px',
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.graph__custom-collapse-button', function () {
	posthogCapture('pdp_collagen_graph_reference_notes_toggled', {
			expanded: $(this).attr('aria-expanded') !== 'true',
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.button_view-studies', function () {
	posthogCapture('pdp_collagen_graph_view_studies_clicked', {
			product_handle: pdpProductHandle
		});
});

// PDP science section (pdp-science-v3 block, shared component - non-Arabic only)
$('body').on('click', '.pdp-science__slider .splide__arrow', function () {
	posthogCapture('pdp_science_slider_arrow_clicked', {
			direction: $(this).hasClass('splide__arrow--prev') ? 'prev' : 'next',
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.pdp-science__button', function () {
	posthogCapture('pdp_science_link_clicked', {
			destination_url: $(this).attr('href'),
			product_handle: pdpProductHandle
		});
});

// Type 2 Collagen graph section only (collagen-type-2-graph-slider-static-v3, a standalone
// top-level section rather than a product-universal-v3 block) - WOMAC score info modal.
// Note: this section's sticky_slider_arrow buttons and its inline .womac-modal-close dismiss
// button have no working click handler in the underlying section file (both are either
// unbound or explicitly commented out there) - not tracked since they're non-functional.
$('body').on('click', '.custom-modal[data-target="#womac-popup"]', function () {
	posthogCapture('pdp_collagen_type2_womac_modal_opened', {
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '#womac-popup .close[data-dismiss="modal"]', function () {
	posthogCapture('pdp_collagen_type2_womac_modal_closed', {
			product_handle: pdpProductHandle
		});
});

// "Other supplements" (WOMAC total score) scientists-slider modal
$('body').on('click', '[data-target="#scientists-slider-popup"]', function () {
	posthogCapture('pdp_collagen_type2_scientists_modal_opened', {
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '#scientists-slider-popup .close[data-dismiss="modal"]', function () {
	posthogCapture('pdp_collagen_type2_scientists_modal_closed', {
			product_handle: pdpProductHandle
		});
});

// Reviews slider (reviews-slider block, shared snippets/reviews-slider-v3.liquid)
$('body').on('click', '.reviews-slider .splide__arrow', function () {
	posthogCapture('pdp_reviews_slider_arrow_clicked', {
			direction: $(this).hasClass('splide__arrow--prev') ? 'prev' : 'next',
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.reviews-slider .splide__pagination__page', function () {
	posthogCapture('pdp_reviews_slider_pagination_clicked', {
			slide_index: $(this).closest('li').index(),
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.reviews-slider-read-more', function () {
	posthogCapture('pdp_reviews_read_more_clicked', {
			product_handle: pdpProductHandle
		});
});

// Customer results before/after slider (customer-results-slider-v4 section)
$('body').on('click', '.customer-results-slider-v4 .splide__arrow', function () {
	posthogCapture('pdp_customer_results_slider_arrow_clicked', {
			direction: $(this).hasClass('splide__arrow--prev') ? 'prev' : 'next',
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.customer-results-slider-v4 .splide__pagination__page', function () {
	posthogCapture('pdp_customer_results_slider_pagination_clicked', {
			slide_index: $(this).closest('li').index(),
			product_handle: pdpProductHandle
		});
});

// Ingredients explorer sliders (ingredients-sliders-v4 section)
$('body').on('click', '.ingredients-slider-v4__tabs-list .ingredients-slider-v4__tab', function () {
	posthogCapture('pdp_ingredients_slider_tab_clicked', {
			ingredient_name: $(this).text().trim(),
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.ingredients-slider-v4__content .splide__arrow', function () {
	posthogCapture('pdp_ingredients_slider_arrow_clicked', {
			direction: $(this).hasClass('splide__arrow--prev') ? 'prev' : 'next',
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.ingredients-slider-v4__slide__external-link a', function () {
	posthogCapture('pdp_ingredients_slider_learn_more_clicked', {
			ingredient_name: $(this).closest('.ingredients-slider-v4__slide').find('.ingredients-slider-v4__slide__name-special').first().text().trim(),
			destination_url: $(this).attr('href'),
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.ingredients-slider-v4__benefits-tabs-container__tab', function () {
	posthogCapture('pdp_ingredients_benefits_tab_clicked', {
			tab: $(this).text().trim(),
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.ingredients-slider-v4__benefits .splide__arrow', function () {
	posthogCapture('pdp_ingredients_benefits_slider_arrow_clicked', {
			direction: $(this).hasClass('splide__arrow--prev') ? 'prev' : 'next',
			product_handle: pdpProductHandle
		});
});

// Competitors comparison table slider (competitors-table-slider-v4 section)
$('body').on('click', '.competitors-table-slider-v4 .splide__arrow', function () {
	posthogCapture('pdp_competitors_table_slider_arrow_clicked', {
			direction: $(this).hasClass('splide__arrow--prev') ? 'prev' : 'next',
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.custom-pagination__page', function () {
	posthogCapture('pdp_competitors_table_slider_pagination_clicked', {
			slide_index: $(this).attr('data-slide'),
			product_handle: pdpProductHandle
		});
});

// "What makes Feel different" benefits card slider (product-benefits-slider-v4 section)
$('body').on('click', '.product-benefits__cards-grid .splide__arrow', function () {
	posthogCapture('pdp_benefits_slider_arrow_clicked', {
			direction: $(this).hasClass('splide__arrow--prev') ? 'prev' : 'next',
			product_handle: pdpProductHandle
		});
});

// Customer testimonials (testimonials-slider-v4 section)
$('body').on('click', '.testimonials__read-more', function () {
	posthogCapture('pdp_testimonials_read_more_toggled', {
			expanded: $(this).closest('.testimonials__review-wrapper').find('.testimonials__review').hasClass('expanded'),
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.testimonials__cards-grid .splide__arrow', function () {
	posthogCapture('pdp_testimonials_slider_arrow_clicked', {
			direction: $(this).hasClass('splide__arrow--prev') ? 'prev' : 'next',
			product_handle: pdpProductHandle
		});
});

// Gradient-background feature slider (gradient-slider-v4 section)
$('body').on('click', '.gradient-slider .splide__arrow', function () {
	posthogCapture('pdp_gradient_slider_arrow_clicked', {
			direction: $(this).hasClass('splide__arrow--prev') ? 'prev' : 'next',
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.gradient-slider .splide__pagination__page', function () {
	posthogCapture('pdp_gradient_slider_pagination_clicked', {
			slide_index: $(this).closest('li').index(),
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.gradient__read-reviews', function () {
	posthogCapture('pdp_gradient_slider_read_reviews_clicked', {
			destination_url: $(this).attr('href'),
			product_handle: pdpProductHandle
		});
});

// "Our formula is real science" product slider + mobile formula-benefits card slider
// (multivitamin-fade-slider-static-v3 section)
$('body').on('click', '.multivitamin-product__slider .splide__arrow', function () {
	posthogCapture('pdp_formula_slider_arrow_clicked', {
			direction: $(this).hasClass('splide__arrow--prev') ? 'prev' : 'next',
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.multivitamin-product__slider .splide__pagination__page', function () {
	posthogCapture('pdp_formula_slider_pagination_clicked', {
			slide_index: $(this).closest('li').index(),
			product_handle: pdpProductHandle
		});
});

$('body').on('click', '.formula-benefits__slider .splide__arrow', function () {
	posthogCapture('pdp_formula_benefits_slider_arrow_clicked', {
			direction: $(this).hasClass('splide__arrow--prev') ? 'prev' : 'next',
			product_handle: pdpProductHandle
		});
});

// Main hero image gallery (snippets/product-hero-slider-v7.liquid). Arrows only render at the
// 992px breakpoint (hidden on mobile in favour of swipe - see pdp_hero_slider_swiped, added
// directly in that file per the "PDP slider swipe/drag tracking" convention). Also matches the
// #product-hero-slider-v7-ab-second id the pdp-slider AB-test experiment gives its cloned slider
// (see the "AB TEST SLIDERS" block in that file) so both instances are covered identically.
$('body').on('click', '#product-hero-slider-v7 .splide__arrow, #product-hero-slider-v7-ab-second .splide__arrow', function () {
	posthogCapture('pdp_hero_slider_arrow_clicked', {
			direction: $(this).hasClass('splide__arrow--prev') ? 'prev' : 'next',
			product_handle: pdpProductHandle
		});
});

// POSTHOG TRACKING - END
